module.exports = __webpack_public_path__ + "files/66eee1f8ca5495dec976cff8ca932711.png";